<template>
  <v-slider
    class="time-radar-slider pl-10 pr-10"
    :class="{playing: !playing}"
    :value="value"
    :step="step"
    :min="min"
    :max="max"
    :tick-labels="tickLabels"
    tick-size="10"
    ticks="always"
    thumb-label="always"
    hide-details
    track-fill-color="grey"
    @input="$emit('input', $event)"
    @mousedown="$emit('mousedown')"
  >
    <template #thumb-label>
      <div class="pa-2 black--text font-weight-bold body-2 thumb-slider-content">
        {{ selectedTime }}
      </div>
    </template>
  </v-slider>
</template>

<script>
export default {
  name: 'TimeRadarSlider',
  props: {
    value: Number,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 1440
    },
    step: {
      type: [Number, String],
      default: 30
    },
    tickLabels: {
      type: Array,
      default () {return []}
    },
    playing: Boolean,
  },
  data () {
    return {}
  },
  computed: {
    selectedTime () {
      let [tempValue, hours] = [this.value ?? 0, 0]
      while (tempValue - 60 >= 0) tempValue -= 60, ++hours
      let ampm = hours >= 12 ? 'PM' : 'AM'
      if (hours > 12) hours -= 12
      return hours.toString() + ':' + (tempValue.toString().length < 2 ? '0' + tempValue.toString() : tempValue.toString()) + ' ' + ampm
    },
  }
}
</script>

<style>
.time-radar-slider .v-slider__thumb-label-container {
  width: min-content;
  white-space: nowrap;
  transform: translateX(-50%) rotate(180deg);
  border-radius: 5px !important;
  z-index: 2;
}
.time-radar-slider .v-slider__thumb-label {
  height: min-content !important;
  width: min-content !important;
  border-radius: 5px !important;
  transform: translateY(-50%) translateX(-50%) !important;
}
.time-radar-slider .v-slider__thumb-label div {
  transform: rotate(-90deg) !important;
}
.time-radar-slider .thumb-slider-content {
  border: 2px solid black;
  border-radius: 5px;
  background-color: white;
}
.time-radar-slider .v-slider__tick {
  border-radius: 50%;
  border: 1px solid black;
  background-color: white;
}
.time-radar-slider .v-slider__tick--filled {
  background-color: rgba(0, 0, 0, 0.3) !important;
  border: none !important;
  transform: scale(0.4);
}
.time-radar-slider.playing .v-slider__tick:not(.v-slider__tick--filled) span :nth-child(3) {
  transform: scale(3);
  background-color: green;
}
</style>